import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/company`;

export const {
  useGetAll: useAllCompany,
  useGet: useCompany,
  useGetAsync: useCompanyAsync,
  useCreate: useCreateCompany,
  useUpdate: useUpdateCompany,
  useDelete: useDeleteCompany,
} = apiCrudBuilder(path, "Company");

export const useDealFlowCompanyStates = (companyId, options) => {
  const { appAxios } = useContext(AuthenticationContext);
  return useQuery({
    ...options,
    queryKey: ["Company", companyId, "DealFlowCompanyState"],
    queryFn: () =>
      appAxios
        .get(`${path}/${companyId}/deal_flow_company_state/`)
        .then((res) => res.data),
  });
};

export const useResetDealFlowCompanyState = () => {
  const queryClient = useQueryClient();

  return (companyId) => {
    queryClient.invalidateQueries({
      queryKey: ["Company", companyId, "DealFlowCompanyState"],
    });
  };
};

export const useDealAndSourcing = (
  companyIds,
  onlyActiveDealsAndSourcings,
  options,
) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: [
      "CompanyDealAndSourcing",
      companyIds,
      onlyActiveDealsAndSourcings,
    ],
    queryFn: () =>
      appAxios
        .get(`${path}/deal_and_sourcing/`, {
          params: {
            companies: companyIds,
            is_active: onlyActiveDealsAndSourcings,
          },
        })
        .then((res) => res.data),
  });
};

export const useDealSnapshotsFromCompany = (companyId, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["Company", companyId, "dealDealSnapshotsFromCompany"],
    queryFn: () =>
      appAxios
        .get(`${path}/${companyId}/deal_snapshots/`)
        .then((res) => res.data),
  });
};

export const useCompanyPeople = (companyId, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["Company", companyId, "people"],
    queryFn: () =>
      appAxios.get(`${path}/${companyId}/people/`).then((res) => res.data),
  });
};

export const useResetCompany = () => {
  const queryClient = useQueryClient();

  return (companyId) => {
    queryClient.invalidateQueries({ queryKey: ["Company", companyId] });
  };
};
